import React from "react";
import { Link } from "react-router-dom";
import { toLower } from "lodash";
import { Box, Flex } from "../../components/Flex";
import { Content } from "../../components/Layout";
import { Title } from "../../components/Text";
import { CloseIcon } from "../../icons/CloseIcon";
import { Scrollbar } from "../../components/Scrollbar";
import { formatDate } from "../../utils";

const AuditDetails = ({ title, data, onClose, renderFieldContent }) => {
    const fields = {
        package: [
            { label: "Package name", attr: "packageName", render: d => <Link to={`/packages/${toLower(d)}`}>{d}</Link> },
            { label: "File name", attr: "filename"},
            { label: "Version", attr: "version" },
            { label: "System Architecture", attr: "sysarch" }
        ],
        user: [
            { label: "Downloaded By", attr: "fullName" },
            { label: "Email", attr: "email", render: d => <Link to={`/users/${toLower(d)}`}>{d}</Link> },
            { label: "Organization", attr: "orgName" },
            { label: "Download Date", attr: "downloadDatetime", render: d => formatDate(d, "DD-MM-YYYY HH:mm:SS") }
        ]
    };

    return(
        <Content background="#FFFFFF" gap={{ bottom: 18 }}>
            <Flex width="100%" justify="space-between" margin={{ bottom: "24px"}}>
                <Title h4>{title}</Title>
                <CloseIcon onClick={onClose} />
            </Flex>
            <Flex height="calc(100% - 108px)">
                <Scrollbar>
                    <Flex justify="space-between" gap={{ right: 18 }}>
                        <Flex direction="column" gap={{ bottom: 16 }}>
                            {renderFieldContent(fields.package, data)}
                        </Flex>
                        <Box flatten background="#F0F4FB" gap={{ bottom: 8 }}>
                            {renderFieldContent(fields.user, data)}
                        </Box>
                    </Flex>
                </Scrollbar>
            </Flex>
        </Content>
    )
};

export { AuditDetails };